export const SUCCESS_FEE_DE = {
  backCta: 'Zurück zum Services',
  moreInfo: 'Mehr Informationen',
  successFee: {
    title: 'Success Fee',
    footer: 'Total success fee',
    successFeeFromSalary: {
      title:
        '$t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) des Gehalts',
      description:
        'Packet $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" }) mal den % des Fees im Vertrag $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }). <br/>Berechnung: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    bonusBenefitOffer: {
      title: '{{ bonusBenefit.description }}',
      description:
        'Variabler Bonus berechnet als Prozent $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) des maximalen vom Bewerber erbrachten Wertes auf Jahresbasis. <br/>Berechnung:  $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ bonusBenefit.amount }}", "currency": "{{ currency }}" })',
    },
    bonusBenefitSalary: {
      title: '{{ bonusBenefit.description }}',
      description:
        'Variabler Bonus, berechnet wie der Pozentanteil $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) des Bruttojahreseinkommens. <br/>Berechnung: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    carBenefit: {
      title: 'Firmenwagen',
      description:
        'Wert des $t(common.formatting.monetary, { "value": "{{ companyCarBenefit.value }}", "currency": "{{ currency }}" }) im Vertrag festgehalten für die Zuteilung des Firmenwagens in Höhe von $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }). <br/>Berechnung: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.monetary, { "value": "{{ companyCarBenefit.value }}", "currency": "{{ currency }}" })',
    },
    healthInsuranceBenefit: {
      title: 'Kranversicherung',
      description:
        'Anteil aus Krankenversicherung von $t(common.formatting.percentage, { "value": "{{ healthInsuranceBenefit.percentage }}" }). <br/>Berechnung: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ healthInsuranceBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    accommodationBenefit: {
      title: 'Anzahl der bezahlten Monatsmieten',
      description:
        'Anteil aus einem Unterkunftsbonus von $t(common.formatting.percentage, { "value": "{{ accommodationBenefit.percentage }}" }). <br/>Berechnung: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ accommodationBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
      // Questa descrizione non corrisponde esattamente alla cifra mostrata, che dipende anche dal numero di mesi dell'accommodation.
    },
    stockOptionsBenefit: {
      title: 'Stock Options',
      description:
        'Anteil aus Stock Options / Unternehmensshareholdings von $t(common.formatting.percentage, { "value": "{{ stocksBenefit.percentage }}" }). <br/>Berechnung: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ stocksBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    overallFee: {
      title: 'Overall fee',
    },
    minimumSuccessFeeAmount: {
      title: 'Mindestbetrag',
      description:
        'Der Wert des gesamten Fee beträgt $t(common.formatting.monetary, { "value": "{{ minimumAmount }}", "currency": "{{ currency }}" }) (Mindestbetrag), in Übereinstimmung mit dem unterzeichneten Vertrag',
    },
  },
  prePayments: {
    title: 'Schon abgerechnete Anzahlungen',
    footer: 'Summe der Anzahlungen',
    retainerFee: {
      title: 'Retainer fee',
    },
    confidenceFee: {
      title: 'Confidence fee',
    },
  },
  total: {
    title: 'Total',
    successFee: {
      title: 'Success fee',
    },
    prePayments: {
      title: 'Bezahlte Vorauszahlung',
    },
    discount: {
      title:
        'Vereinbarter Rabatt ($t(common.formatting.percentage, { "value": "{{ discountPercentage }}" }))',
    },
    minimumSuccessFeeAmount: {
      title: '$t(successFee.successFee.minimumSuccessFeeAmount.title)',
      description:
        '$t(successFee.successFee.minimumSuccessFeeAmount.description)',
    },
  },
};
